import React,{Component} from 'react'
import type from './decorator'

class IdentityLookup extends Component{
    render(){
        const {onChange,validationState,errorsFor,config} = this.props
            return null
    }
}

export default type({
    label:'identity',
    type:'identity',
    properties:[],
    config:{},
    validations:{}
})(IdentityLookup)